import React from 'react';

const separateWithDots = (array, color = '#333333') =>
  array.map((element, idx) => (
    <span key={idx}>
      {idx > 0 ? <span style={{ color, margin: '0 3px' }}>•</span> : ''}
      {element}
    </span>
  ));

export default separateWithDots;
